import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const FormProgress = ({ steps, currentStep }) => {
  const stepIsActive = step => {
    return step <= currentStep;
  };

  return (
    <ul className="form-progress">
      {steps.map(step => {
        const { number, title } = step;
        const stepClasses = classNames({
          'form-progress__step': true,
          [`form-progress__step--${number}`]: true,
          'form-progress__step--active': stepIsActive(number),
        });

        return (
          <li key={number} className={stepClasses} data-testid="step">
            <span className="form-progress__step-no">{number}</span>
            <span className="form-progress__step-title">{title}</span>
          </li>
        );
      })}
    </ul>
  );
};

FormProgress.propTypes = {
  steps: PropTypes.array,
  currentStep: PropTypes.number,
};

FormProgress.defaultProps = {
  currentStep: 1,
};

export default FormProgress;
